import MinistryRelationService from "../../services";

export default {
  namespaced: true,
  state: {
    incentives: {
      punishments: [],
      rewards: [],
    },
    loading: false,
    incentive: {},
  },
  getters: {
    incentives(state) {
      return state.incentives;
    },
    loading(state) {
      return state.loading;
    },
    incentive(state) {
      return state.incentive;
    },
  },
  mutations: {
    setData(state, payload) {
      state.incentives = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setShowData(state, payload) {
      state.incentive = payload;
    },
  },
  actions: {
    async getIncentive({ commit }, id) {
      commit("setLoading", true);
      try {
        const data = await MinistryRelationService.getIncentive(id);
        commit("setShowData", data.data);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    async getIncentives({ commit }) {
      commit("setLoading", true);
      try {
        const data = await MinistryRelationService.getIncentives();
        commit("setData", data.data);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
  },
};
